class ListCollections extends HTMLElement {
  constructor() {
    super();

    this.swiperInit();
  }

  swiperInit() {
    const listCollectionSwipers = this.querySelectorAll('[data-list-collection-swiper]');

    listCollectionSwipers.forEach((listCollectionSwiper) =>{
      const listCollection = listCollectionSwiper.closest('[data-list-collection]');
      const pagination = listCollection.querySelector('[data-swiper-pagination]');
      const prevButton = listCollection.querySelector('[data-swiper-prev]');
      const nextButton = listCollection.querySelector('[data-swiper-next]');
      const slideCounter = listCollection.querySelector('[data-slide-counter]');

      const swiper = new window.Swiper(listCollectionSwiper, {
        spaceBetween: 0,
        slidesPerView: 1,
        draggable: true,
        loop: false,
        pagination: {
          el: pagination,
          clickable: true
        },
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        }
      });

      slideCounter.innerHTML = (swiper.activeIndex +  1) + '/' + swiper.slides.length;

      swiper.on('slideChangeTransitionStart', () => {
        slideCounter.innerHTML = (swiper.activeIndex +  1) + '/' + swiper.slides.length;
      });

      return swiper;
    });
  }
}

customElements.define('list-collections', ListCollections);